// useMyDetails.js
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

/**
 * Fetch the current user's extended details (teams, etc.).
 * Cached by React-Query, so the request runs once per tab.
 */
const fetchMyDetails = async () => {
  const { data } = await axios.get('/api/users/my-details/', {
    withCredentials: true,          // already defaulted, but harmless
  });
  return data;
};

/**
 * Hook : returns { data, isLoading, error }
 * • Compatible with React-Query v5
 * • Still exposes the same field names your components expect.
 */
export default function useMyDetails() {
  const {
    data,
    error,
    isPending,          // v5 naming
  } = useQuery({
    queryKey: ['my-details'],
    queryFn: fetchMyDetails,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  /* map v5 → v4 field names so the rest of your code stays untouched */
  return {
    data,
    error,
    isLoading: isPending,
  };
}